import { AppCollapsible, Flex, PageContainer } from '@/components';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default function FAQPage() {

  const [t] = useTranslation(['common', 'faq']);

  const questions = useMemo(() => {
    return t('faq:questions.nurture', { returnObjects: true }) as any[];
  }, [t]);

  return (
    <PageContainer title={t('faq:labels.faq')}>
      <Flex direction="column" gap={12}>
        <AppCollapsible items={questions} />
      </Flex>
    </PageContainer>
  );
}
